<template>
  <FlexLayout>
    <vue-loading :active="isLoading" :is-full-page="true" />

    <BlockContainer id="loginContainer" class="row" :title="$t('login.subTitle.login')" v-if="config.LOGIN.default.enabled || config.LOGIN.sso.enabled" role="region">
      <!-- TODO <p>{{ $t('login.label.loginInfo') }}</p> -->
      <form @submit.stop.prevent>
        <div v-if="config.LOGIN.default.enabled">
          <Input
            id="emailAddr"
            :label="$t('login.label.email')"
            type="email"
            v-model="$v.form.emailAddr.$model"
            :error="$v.form.emailAddr.$dirty && $v.form.emailAddr.$error ? $t('validation.invalidEmail') : ''"
            :required="true"
            :maxlength="config.CUSTOMER_DATA.FIELDS.emailAddr.maxLength"
            aria-describedby="login-form-email"
          />
          <Input
            id="password"
            :label="$t('login.label.password')"
            type="password"
            v-model="$v.form.password.$model"
            :error="$v.form.password.$dirty && $v.form.password.$error ? $t('validation.fieldWarningRequired') : ''"
            :required="true"
            :maxlength="config.CUSTOMER_DATA.FIELDS.password.maxLength"
            aria-describedby="login-form-password"
          />

          <div v-if="config.LOGIN.default.rememberMe">
            <fieldset class="remember-me-row" aria-labelledby="rememberMeLabel">
              <input type="checkbox" id="rememberMe" v-model="rememberMe" style="margin-right: 15px;" />
              <label for="rememberMe" id="rememberMeLabel" >{{ $t('login.label.rememberMe') }}</label>
            </fieldset>
          </div>


          <a class="forgot-password-link" href="#" @click.prevent="goToForgotPassword">{{ $t('login.label.forgotPassword') }}</a>
          <Button type="submit" @click.stop="onClickCaptcha" :disabled="submitStatus === 'PENDING'">{{ $t('login.button.login') }}</Button>

          <div v-if="config.LOGIN.sso.enabled" class="login-separator my-3 d-flex align-items-center w-100" style="width: 100%;">
            <!-- todo PR - this color is static ! -->
            <hr class="flex-grow-1 m-0" style="border-top: 1px solid #ccc;" aria-hidden="true">
            <span class="mx-3 text-center" style="white-space:nowrap;" role="separator">{{ $t('text.loginWith') }}</span>
            <hr class="flex-grow-1 m-0" style="border-top: 1px solid #ccc;" aria-hidden="true">
          </div>
        </div>
        <div v-if="config.LOGIN.sso.enabled" class="login-sso-row">
          <Button
            @click.stop="loginSSO"
            :disabled="submitStatus === 'PENDING'"
            :icon-type="config.LOGIN.sso.icon.type"
            :icon-left="config.LOGIN.sso.icon.name"
          >
            {{ $t('login.button.sso') }}
          </Button>
        </div>
      </form>
    </BlockContainer>
    <BlockContainer v-if="config.REGISTRATION.enabled || config.REGISTRATION_PARENT.enabled || config.GUEST_CHECKOUT.enabled" :title="$t('login.subTitle.register')" role="region">
      <p>{{ $t('login.label.registerInfo') }}</p>
      <template #actions>
        <Button v-if="config.REGISTRATION.enabled" @click.stop="goToRegister">{{ $t('login.button.register') }}</Button>
        <Button v-if="config.REGISTRATION_PARENT.enabled" @click.stop="goToRegisterParent">{{ $t('login.button.registerParent') }}</Button>
        <Button v-if="config.GUEST_CHECKOUT.enabled" @click.stop="goToRegisterGuest">{{ $t('login.button.registerGuest') }}</Button>
      </template>
    </BlockContainer>
  </FlexLayout>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import VueLoading from 'vue-loading-overlay';
import Utils from "@/utils/utils";
import {accountService} from "@/services/api/accountService";
import {useCustomerStore} from "@/stores/customer";
import {useLocaleStore} from "@/stores/locale";
import {useAuthStore} from "@/stores/auth";
import {useAppStore} from "@/stores/app";
import {Login} from "@/constants/constants";
import Button from "@/components/actions/Button.vue";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import Input from "@/components/forms/Input.vue";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";
import { loginSSO } from "@/utils/ssoUtils";
import {getAuthenticatedHomeRouteName, getSafeAuthenticatedRedirect} from "@/utils/authRouteUtils";

export default {
    data() {
        return {
            submitStatus: null,
            alert: {
                message: "hello world"
            },
            form: {
                emailAddr: undefined,
                password: undefined,
            },
            formErrorMessage : null,
            siteKey: "",
            responseToken: "",
            hidePassword: true,
            rememberMe: false,
            isLoading: false,
            submit: false,
        }
    },
    computed: {
        config(){
            return window.config;
        },
    },
    validations: {
       form: {
          emailAddr: {
              required,
              email
          },
         password: {
           required,
         },
      },
    },
    components: {
      Input,
      BlockContainer,
      Button,
      VueLoading,
      FlexLayout,
    },
    setup() {
      const localeStore = useLocaleStore();
      const authStore = useAuthStore();
      const customerStore = useCustomerStore();
      const appStore = useAppStore();

      return {
        localeStore,
        authStore,
        customerStore,
        appStore
      };
    },
    methods: {
      handleLoginSuccess() {
        const redirectRouteName = this.appStore.redirectRouteName
        if (redirectRouteName) {
          const redirectTarget = getSafeAuthenticatedRedirect(
            this.authStore,
            this.config,
            redirectRouteName,
            this.appStore.redirectRouteParams,
            this.appStore.redirectRouteQuery,
          );
          console.log("Redirecting to last route:", redirectRouteName);
          this.appStore.clearRedirectRoute();
          this.$navigate(redirectTarget.name, {
            params: redirectTarget.params,
            query: redirectTarget.query,
            withReplace: true,
          });
        } else {
          this.$navigate(getAuthenticatedHomeRouteName(this.config, this.authStore), { withReplace: true });
        }
      },
      async changeLanguage(newLocale) {
        await this.localeStore.setLocale(newLocale);
      },
      // eslint-disable-next-line no-undef
      onClickCaptcha(e) {
          this.submit = true;
          console.debug("onClickCaptcha");
          e.preventDefault();
          if(this.config.G_CAPTCHA.enabled === true && typeof grecaptcha !== 'undefined')
          {
            const self = this;
            // eslint-disable-next-line no-undef
            grecaptcha.ready(function() {
              // eslint-disable-next-line no-undef
              grecaptcha.execute(this.config.G_CAPTCHA.siteKey, {action: 'submit'}).then(function(token) {
                self.responseToken = token;
                self.onSubmit(e);
              });
            });
          }
          else
          {
              this.onSubmit(e);
          }
      },
      goToForgotPassword() {
        this.$navigateToForgotPassword();
      },
      goToRegister() {
        this.$navigateToRegister();
      },
      goToRegisterParent() {
        this.$navigateToRegisterParent();
      },
      goToRegisterGuest() {
        this.$navigateToRegisterGuest();
      },
      async loginSSO() {
        await loginSSO();
      },
      async onSubmit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.makeToast('danger', this.$t('notification.fillAllRequiredFields'));
          return;
        }

        this.formErrorMessage = null;

        this.isLoading = true;
        /** @type {AfterLoginResponse|ErrorResponse} */
        const result = await accountService.login(this.form.emailAddr, this.form.password, this.responseToken, this.rememberMe);
        this.isLoading = false;

        if (result.exception !== undefined) {
          this.makeToast('danger', this.$t('login.messages.error.onLogin'));
          return;
        }
        else if (result.errorCode === -7) {
          this.makeToast('danger', this.$t('login.messages.error.onLoginBlocked'));
          return;
        }

        if (result.errorCode >= 0) {
          this.authStore.setAuthenticated(true, Login.Mode.STANDARD, Login.UserType.REGISTERED_USER);

          if (result.page === "tcp.catalog.change.password.page") {
            this.$navigateToPasswordReset();
            return;
          }

          if (this.config.USE_ALLERGEN_FILTERS && result.wondCustomer.dietaryInfo !== undefined) {
            this.customerStore.setDietaryInfo(result.wondCustomer.dietaryInfo);
          }

          const newLocale = !Utils.isEmpty(result.customer.locale) ? result.customer.locale : this.config.LANGUAGE_LIST[0].value;
          await this.changeLanguage(newLocale.replace('-', '_'));

          this.handleLoginSuccess();
        } else {
          if (this.config.USE_SPECIFIC_ERROR_MESSAGE_TPCLOGIN) {
            if (result.errorCode === -1 || result.errorCode === -2 || result.errorCode === -3 || result.errorCode === -4 || result.errorCode === -6) {

              this.formErrorMessage = result.errorMsg;

              const h = this.$createElement;
              const message = h('div', [
                this.$t('login.messages.error.onLogin'),
                h('br'),
                h('br'),
                this.$t('login.messages.error.onLoginSpecific'),
              ]);

              this.makeToast('danger', [message]);
            } else {
              this.formErrorMessage = result.errorMsg;
              this.makeToast('danger', this.$t('login.messages.error.onLogin'));
            }
          } else {
            this.formErrorMessage = result.errorMsg;
            this.makeToast('danger', this.$t('login.messages.error.onLogin'));
          }
        }
      }
    },
    async created() {
      const flashToast = this.appStore.consumeFlashToast();

      this.isLoading = true;
      const result = await accountService.beforeLogin();
      this.isLoading = false;

      if (flashToast?.variant && flashToast?.message) {
        this.makeToast(flashToast.variant, flashToast.message);
      }

      if (result.exception !== undefined) {
        this.makeToast('danger', this.$t('login.messages.error.onLogin'));
      }
    },
    mounted(){
        this.siteKey = this.config.G_CAPTCHA.siteKey;
    },
}
</script>

<style scoped>
  input[type="password"]::-ms-reveal {
    display: none;
  }

  .forgot-password-link {
    text-align: right;
    display: block;
    margin-bottom: 10px;
  }

  input[type="checkbox"] {
    appearance: auto;
    -webkit-appearance: checkbox;
    -moz-appearance: checkbox;
    accent-color: var(--primary-color);
    display: inline-block;
    border: initial;
    border-radius: initial;
  }


</style>
